/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Optimization status enum
 */
export enum OptimizationStatus {

    Pending = 'Pending',

    Running = 'Running',

    Completed = 'Completed',

    Failed = 'Failed',

    Cancelled = 'Cancelled'
}
